import React from "react";
import { DataView, dataViewFilterName, DataViews, DataViewsProvider } from "../data.views";
import { DataViewNavBarLayoutProvider } from "../navbar_layout/data.view.nav.bar.layout";
import { SimpleDataNavBarViewLayout } from "../navbar_layout/simple.data.view.nav.bar.layout";
import { TestOneLineLayout, TestSearchResultLayout } from "./test.search.result.layout";
import { BaseDataSourceDetails } from "@me8eon/data_sources";
import { SimpleSelectableButton } from "@me8eon/selection_button";
import { FeatureFlags, FeatureFlagsStateProvider } from "@me8eon/featureflags";
import { CommonComponentsProvider } from "@me8eon/components";
import { DebugStateProvider } from "@me8eon/debug";
import { DataPluginProvider, DataPlugins } from "@me8eon/data";
import { TestDataPlugins } from "@me8eon/all_data";
import { AttributeValueProvider, SimpleAttributeValueLayout, SimpleDataLayout } from "@me8eon/renderers";
import { allRenderers } from "@me8eon/all_renderers";
import { RawThemeProvider, themeForTests } from "@me8eon/themes";
import { commonComponentsFn } from "@me8eon/allcomponents";
import { GuiFilterProvider } from "@me8eon/filters";
import { LoginContext } from "@me8eon/react_authentication";

export const TestDataSourceJiraFromDS1: BaseDataSourceDetails = {
    type: "someDataSource1",
    names: ["jira"],
};
export const TestDataSourceJiraConfluenceFromDS1: BaseDataSourceDetails = {
    type: "someDataSource1",
    names: ["jira", "confluence", "mygenius"],
};
export const TestDataSourcePeopleFromDS1: BaseDataSourceDetails = {
    type: "someDataSource1",
    names: ["people"],
};
export const TestDataSourceJiraFromJql: BaseDataSourceDetails = {
    type: "jql",
    names: ["jira"],
};
export const TestDataSourceMyGeniusDS1: BaseDataSourceDetails = {
    type: "someDataSource1",
    names: ["mygenius"],
};
export const TestDataSourceGitLabDS1: BaseDataSourceDetails = {
    type: "someDataSource1",
    names: ["gitlab"],
};


export const TestDataViewCommon = {
    plugin: "dataview" as const,
    DisplayNavItem: SimpleSelectableButton,
    SearchResultLayout: TestSearchResultLayout,
    OneLineLayout: TestOneLineLayout,
};
type TestFixtureSearchType = "submit" | "immediate"
export const TestDataViewAll: DataView<TestFixtureSearchType, BaseDataSourceDetails> = {
        ...TestDataViewCommon,
        searchIndices: ["jira", "confluence", "people", "mygenius", "gitlab"],
        search: {
            submit: {
                dataSource: [TestDataSourceJiraFromJql, TestDataSourcePeopleFromDS1, TestDataSourceJiraConfluenceFromDS1, TestDataSourceMyGeniusDS1, TestDataSourceGitLabDS1],
            },
            immediate: {
                dataSource: [TestDataSourceJiraFromJql, TestDataSourcePeopleFromDS1, TestDataSourceJiraConfluenceFromDS1, TestDataSourceMyGeniusDS1, TestDataSourceGitLabDS1],
            },
        },
        needsOffice: false,
        changeView: {
            forceSearchWhenSelectView: true,
            cleanWhenSelectView: true,
        },

        widgets: ["apps", "sharepoint", "restOfElasticSearch"],

    }
;
export const TestDataViewJira: DataView<TestFixtureSearchType, BaseDataSourceDetails> = {
    ...TestDataViewCommon,
    searchIndices: ["jira"],
    search: {
        submit: {
            dataSource: [TestDataSourceJiraFromDS1, TestDataSourceJiraFromJql],
        },
        immediate: {
            dataSource: [TestDataSourceJiraFromDS1, TestDataSourceJiraFromJql],
        },
    },
    widgets: ["jira"],
    needsOffice: false,
    changeView: {
        forceSearchWhenSelectView: true,
        cleanWhenSelectView: true,
    },


};
export const TestDataViewConfluence: DataView<TestFixtureSearchType, BaseDataSourceDetails> = {
    ...TestDataViewCommon,
    searchIndices: ["confluence"],

    search: {
        submit: {
            dataSource: [TestDataSourceJiraConfluenceFromDS1],
        },
        immediate: {
            dataSource: [TestDataSourceJiraConfluenceFromDS1],
        },
    },
    widgets: ["confluence"],
    needsOffice: false,
    changeView: {
        forceSearchWhenSelectView: true,
        cleanWhenSelectView: true,
    },


};
export const TestDataViewPeople: DataView<TestFixtureSearchType, BaseDataSourceDetails> = {
    ...TestDataViewCommon,
    searchIndices: ["people"],
    search: {
        submit: {
            dataSource: [TestDataSourcePeopleFromDS1],
        },
        immediate: {
            dataSource: [TestDataSourcePeopleFromDS1],
        },
    },
    widgets: ["people"],
    needsOffice: false,
    changeView: {
        forceSearchWhenSelectView: true,
        cleanWhenSelectView: true,
    },


};
export const TestDataViewMyGenius: DataView<TestFixtureSearchType, BaseDataSourceDetails> = {
    ...TestDataViewCommon,
    searchIndices: ["mygenius"],
    search: {
        submit: {
            dataSource: [TestDataSourceMyGeniusDS1],
        },
        immediate: {
            dataSource: [TestDataSourceMyGeniusDS1],
        },
    },
    widgets: ["myGenius"],
    needsOffice: false,
    changeView: {
        forceSearchWhenSelectView: true,
        cleanWhenSelectView: true,
    },

};
export const TestDataViewGitLab: DataView<TestFixtureSearchType, BaseDataSourceDetails> = {
    ...TestDataViewCommon,
    searchIndices: ["gitlab"],
    search: {
        submit: {
            dataSource: [TestDataSourceGitLabDS1],
        },
        immediate: {
            dataSource: [TestDataSourceGitLabDS1],
        },
    },
    widgets: ["gitlab"],
    needsOffice: false,
    changeView: {
        forceSearchWhenSelectView: true,
        cleanWhenSelectView: true,
    },

};
export const TestDataViews: DataViews<TestFixtureSearchType, BaseDataSourceDetails> = {
    all: TestDataViewAll,
    jira: TestDataViewJira,
    confluence: TestDataViewConfluence,
    people: TestDataViewPeople,
    myGenius: TestDataViewMyGenius,
    gitlab: TestDataViewGitLab,
};

export type TestDataViewProviderProps<Details = BaseDataSourceDetails> = {
    initialDataView?: string
    dataViews?: (featureFlags: FeatureFlags) => DataViews<TestFixtureSearchType, Details>
    dataPlugins?: DataPlugins
    children: React.ReactNode
    featureFlags?: FeatureFlags
}
export const TestDataViewProvider: React.FC<TestDataViewProviderProps> = ({
                                                                              children,
                                                                              dataViews = () => TestDataViews,
                                                                              initialDataView = "all",
                                                                              dataPlugins = TestDataPlugins,
                                                                              featureFlags = {},
                                                                          }) => {
    return (
        <RawThemeProvider theme={themeForTests}>
            <FeatureFlagsStateProvider featureFlags={featureFlags}>
                <LoginContext.Provider value={{ loginOps: { userData: { featureFlagEnabled: false } } } as any}>
                    <DebugStateProvider debugState={{}}>
                        <GuiFilterProvider guiFilters={{ [dataViewFilterName]: initialDataView }}>
                            <DataViewNavBarLayoutProvider dataViewLayout={SimpleDataNavBarViewLayout}>
                                <DataViewsProvider dataViews={dataViews}>
                                    <DataPluginProvider dataPlugins={dataPlugins}>
                                        <CommonComponentsProvider componentsFn={commonComponentsFn}>
                                            <AttributeValueProvider renderers={allRenderers} AttributeValueLayout={SimpleAttributeValueLayout} DataLayout={SimpleDataLayout}>
                                                {children}
                                            </AttributeValueProvider>
                                        </CommonComponentsProvider>
                                    </DataPluginProvider>
                                </DataViewsProvider>
                            </DataViewNavBarLayoutProvider>
                        </GuiFilterProvider>
                    </DebugStateProvider>
                </LoginContext.Provider>
            </FeatureFlagsStateProvider>
        </RawThemeProvider>
    );
};

